// import { lazy } from 'react';
import SalesLayOut from "views/Sales-Sections/SalesLayOut";
import BatchPrint from "views/PrintTypes/BatchPrint";
import Print from "views/print/Print";
import A4Print from "views/PrintTypes/A4Print";
import A4PrintTwo from "views/PrintTypes/A4PrintTwo";
import DeliveryNotePrint from "views/PrintTypes/DeliveryNotePrint";
import ThermalPrint from "views/PrintTypes/ThermalPrint";
import A4PurchasePrint from "views/PrintTypes/A4PurchasePrint";
import ThermalPurchase from "views/PrintTypes/ThermalPurchase";
import A4PrintTaxVAt from "views/PrintTypes/TaxVat/A4PrintTaxVAt";
import ThermalPrintTaxVat from "views/PrintTypes/TaxVat/ThermalPrintTaxVat";
import ThermalPrintTaxVat2 from "views/PrintTypes/TaxVat/ThermalPrintTaxVat2";
import ReceiptPaymentPrint from "views/PrintTypes/ReceiptPaymentPrint";
import ThermalInch from "views/PrintTypes/ThermalInch";
import SalesReportPrint from "views/PrintTypes/SalesReportPrint";
import SalesReportReturnPrint from "views/PrintTypes/SalesReportReturnPrint";
import EmployeeWiseReportPrint from "views/PrintTypes/EmployeeReport";
import QuotationPrintTemplate from "views/PrintTypes/QuotationPrintTemplate";

import CustomPrint from "views/reports/components/CustomPrint";
import CustomPrintStock from "views/reports/components/CustomPrintStock";
import CashFlowReportPrint from "views/PrintTypes/CashFlowReportPrint";
import NewInvoicePrintTemplate from "views/PrintTypes/NewInvoicePrintTemplate";

const PrinterRoutes = {
  path: "printer",
  element: <SalesLayOut />,
  children: [
    {
      path: "printerCheck",
      element: <Print />,
    },
    {
      path: "quotationPrint",
      element: <QuotationPrintTemplate />,
    },
    {
      path: "thermalPrint",
      element: <ThermalPrint />,
    },
    {
      path: "a4",
      element: <A4Print />,
    },
    {
      path: "a4Two",
      element: <A4PrintTwo />,
    },
    {
      path: "deliveryNote",
      element: <DeliveryNotePrint />,
    },
    {
      path: "batchPrint",
      element: <BatchPrint />,
    },
    {
      path: "purchaseA4",
      element: <A4PurchasePrint />,
    },
    {
      path: "purchaseThermal",
      element: <ThermalPurchase />,
    },
    {
      path: "lazerA4PrintTaxVat",
      element: <A4PrintTaxVAt />,
    },
    {
      path: "ThermalPrintTaxVat",
      element: <ThermalPrintTaxVat />,
    },
    {
      path: "ThermalPrintTaxVat2",
      element: <ThermalPrintTaxVat2 />,
    },
    {
      path: "a5Print",
      element: <ReceiptPaymentPrint />,
    },
    {
      path: "thermalPrint4Inch",
      element: <ThermalInch />,
    },
    {
      path: "salesReportPrint",
      element: <SalesReportPrint />,
    },
    {
      path: "salesReportReturnPrint",
      element: <SalesReportReturnPrint />,
    },
    {
      path: "employeeReportPrint",
      element: <EmployeeWiseReportPrint />,
    },
    {
      path: "stockReportPrint",
      element: <CustomPrint />,
    },
    {
      path: "customPrintStock",
      element: <CustomPrintStock />,
    },
    {
      path: "cashFlowReportPrint",
      element: <CashFlowReportPrint />,
    },
    {
      path: "newInvoicePrint",
      element: <NewInvoicePrintTemplate />,
    },
  ],
};
export default PrinterRoutes;
